// @ts-nocheck
import React from 'react';
import { Menu, MenuItem, MenuDivider } from '@blueprintjs/core';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage as T } from '@/components';
import preferencesMenu from '@/constants/preferencesMenu';
import { useUserType } from '@/hooks/query';
import PreferencesSidebarContainer from './PreferencesSidebarContainer';

import '@/style/pages/Preferences/Sidebar.scss';

/**
 * Preferences sidebar.
 */
export default function PreferencesSidebar() {
  const history = useHistory();
  const location = useLocation();
  const userType = String(useUserType() || '').toLowerCase();

  const items = preferencesMenu
    .filter((item) => {
      if (!Array.isArray(item.userTypes)) return true;
      return item.userTypes
        .map((type) => String(type || '').toLowerCase())
        .includes(userType);
    })
    .map((item) =>
    item.divider ? (
      <MenuDivider key={item.title || item.href} title={item.title} />
    ) : (
      <MenuItem
        key={item.href}
        active={item.href && item.href === location.pathname}
        text={item.text}
        label={item.label}
        disabled={item.disabled}
        onClick={() => {
          history.push(item.href);
        }}
      />
    ));

  return (
    <PreferencesSidebarContainer>
      <div class="preferences-sidebar__head">
        <h2>{<T id={'preferences'} />}</h2>
      </div>

      <Menu className="preferences-sidebar__menu">{items}</Menu>
    </PreferencesSidebarContainer>
  );
}
